import './mail-in-process-workspace.component.ajscss';

import { IEpticaDeprecatedService } from '@agent/core/channel-digit/mail/eptica/eptica-deprecated.service';
import { IEpticaRequestFrame } from '@agent/core/channel-digit/mail/eptica/models/eptica.request.interfaces';
import { IContactDeprecatedService } from '@agent/core/contact/contact-deprecated.service';
import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './mail-in-process-workspace.component.html';

export class MailInProcessWorkspaceCtrl implements IComponentController {
  public request: IEpticaRequestFrame;
  responseId: string;

  constructor(protected contactDeprecatedService: IContactDeprecatedService, protected epticaDeprecatedService: IEpticaDeprecatedService) {}

  $onInit(): void {
    this.contactDeprecatedService
      .getContact(this.responseId)
      .then(contact => {
        return this.epticaDeprecatedService.loadRequest({
          requestId: contact.epticaRequestId || 0,
          responseId: this.responseId,
        });
      })
      .then(request => {
        this.onEpticaFrameReady(request);
      });
  }

  private onEpticaFrameReady(request: IEpticaRequestFrame) {
    this.request = request;
  }
}

export class MailInProcessWorkspace implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
    request: '<',
  };
  controller = ['contactDeprecatedService', 'epticaDeprecatedService', MailInProcessWorkspaceCtrl];
}

export default 'contactMailInProcessWorkspace';
